<template>
    <!-- 全局底部版权声明 -->
<!--	<div class="layout-footer">
        <span class="copyright">&#169; The copyright of this system belongs to Beijing Bio-LIMS Software Technology Co., Ltd</span>
    </div>-->
</template>

<script>
export default {
	props: {
		colorScheme: String
	}
}
</script>

